/* 3JIndustry Pro — theme script (vanilla, no dependencies, loaded with defer).
   Everything here is an enhancement: every form and link also works without JavaScript. */
(function () {
  'use strict';

  var dataEl = document.getElementById('ThemeData');
  var T = { routes: {}, strings: {}, cartType: 'page', currency: 'USD', locale: 'en', predictive: true };
  try { if (dataEl) T = JSON.parse(dataEl.textContent); } catch (e) { /* keep defaults */ }
  var S = T.strings || {};
  var R = T.routes || {};

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n;
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function formatPrice(value) {
    var n = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(T.locale || 'en', { style: 'currency', currency: T.currency || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  var toastEl = document.getElementById('ThemeToast');
  var toastTimer;
  function toast(message, isError, link) {
    if (!toastEl) return;
    toastEl.textContent = '';
    toastEl.appendChild(document.createTextNode(message));
    if (link) {
      var a = el('a', '', link.label); a.href = link.href; a.style.color = '#fff'; a.style.marginLeft = '10px';
      toastEl.appendChild(a); toastEl.style.pointerEvents = 'auto';
    } else { toastEl.style.pointerEvents = 'none'; }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4200);
  }

  /* ---------- header: mega menus and mobile drawer ---------- */
  var megas = $$('[data-mega]');
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  megas.forEach(function (d) {
    on(d, 'toggle', function () {
      if (d.open) megas.forEach(function (o) { if (o !== d) o.open = false; });
    });
    if (finePointer) {
      var timer;
      on(d.parentElement, 'mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { d.open = true; }, 90); });
      on(d.parentElement, 'mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { d.open = false; }, 160); });
    }
  });
  on(document, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    megas.forEach(function (d) { if (d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); } });
    var drawer = $('[data-menu-drawer]');
    if (drawer && drawer.open) { drawer.open = false; $('summary', drawer).focus(); }
  });
  on(document, 'click', function (e) {
    megas.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  var menuDrawer = $('[data-menu-drawer]');
  if (menuDrawer) {
    on(menuDrawer, 'click', function (e) {
      if (e.target === menuDrawer) { menuDrawer.open = false; }
    });
    on(menuDrawer, 'toggle', function () { document.documentElement.style.overflow = menuDrawer.open ? 'hidden' : ''; });
    on(window, 'resize', debounce(function () {
      if (window.innerWidth >= 990 && menuDrawer.open) menuDrawer.open = false;
    }, 150));
  }

  /* ---------- localization: submit on change ---------- */
  $$('[data-localization-form] select').forEach(function (s) {
    on(s, 'change', function () { s.form.submit(); });
  });

  /* ---------- predictive search (combobox) ---------- */
  function initPredictive(form) {
    var input = $('input[type="search"]', form);
    var panel = document.getElementById(form.getAttribute('data-results-id'));
    var status = $('[data-predictive-status]', form);
    if (!input || !panel || !R.predictiveSearch || T.predictive === false) return;
    var listId = panel.id + '-list';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-haspopup', 'listbox');
    var controller, options = [], active = -1, lastQuery = '';

    function close() {
      panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1;
    }
    function setActive(i) {
      options.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
      active = i;
      if (i >= 0 && options[i]) {
        options[i].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', options[i].id);
        options[i].scrollIntoView({ block: 'nearest' });
      } else { input.removeAttribute('aria-activedescendant'); }
    }
    function highlight(target, text, q) {
      var lower = text.toLowerCase(), term = q.toLowerCase().trim(), idx = term ? lower.indexOf(term) : -1;
      if (idx < 0) { target.textContent = text; return; }
      target.appendChild(document.createTextNode(text.slice(0, idx)));
      target.appendChild(el('mark', '', text.slice(idx, idx + term.length)));
      target.appendChild(document.createTextNode(text.slice(idx + term.length)));
    }
    function option(url, build, extraClass) {
      var li = el('li', extraClass || 'predictive__item');
      li.setAttribute('role', 'option');
      li.id = listId + '-o' + options.length;
      li.setAttribute('aria-selected', 'false');
      var a = el('a'); a.href = url; a.tabIndex = -1; build(a); li.appendChild(a);
      options.push(li);
      return li;
    }
    function group(list, label, items, render) {
      if (!items || !items.length) return;
      var g = el('li', 'predictive__group'); g.setAttribute('role', 'presentation');
      var hid = listId + '-g' + label.replace(/\W+/g, '');
      var h = el('p', 'predictive__heading', label); h.id = hid; g.appendChild(h);
      var ul = el('ul', 'predictive__list'); ul.setAttribute('role', 'group'); ul.setAttribute('aria-labelledby', hid);
      items.forEach(function (item) { ul.appendChild(render(item)); });
      g.appendChild(ul); list.appendChild(g);
    }
    function render(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      options = []; active = -1;
      panel.textContent = '';
      var list = el('ul', 'predictive__list'); list.id = listId; list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', S.searchProducts || 'Suggestions');
      group(list, S.searchProducts || 'Products', res.products, function (p) {
        return option(p.url, function (a) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) {
            var im = el('img', 'predictive__thumb'); im.src = sizedImage(img, 96); im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy';
            a.appendChild(im);
          } else { a.appendChild(el('span', 'predictive__thumb predictive__thumb--empty', '—')); }
          var t = el('span', 'predictive__text');
          var title = el('span', 'predictive__title'); highlight(title, p.title || '', q); t.appendChild(title);
          var meta = [p.vendor && p.vendor.toUpperCase() !== '3JINDUSTRY' ? p.vendor : '', p.type || p.product_type || ''].filter(Boolean).join(' · ');
          var avail = p.available === false ? (S.outOfStock || 'Out of stock') : (S.inStock || 'In stock');
          t.appendChild(el('span', 'predictive__meta', (meta ? meta + ' · ' : '') + avail));
          a.appendChild(t);
          var price = p.price_min || p.price;
          if (price != null && price !== '') a.appendChild(el('span', 'predictive__price', formatPrice(price)));
        });
      });
      group(list, S.searchCollections || 'Categories', res.collections, function (c) {
        return option(c.url, function (a) { var t = el('span', 'predictive__text'); var s = el('span', 'predictive__title'); highlight(s, c.title || '', q); t.appendChild(s); a.appendChild(t); });
      });
      var content = (res.articles || []).concat(res.pages || []);
      group(list, S.searchArticles || 'Guides', content, function (c) {
        return option(c.url, function (a) { var t = el('span', 'predictive__text'); var s = el('span', 'predictive__title'); highlight(s, c.title || '', q); t.appendChild(s); a.appendChild(t); });
      });
      var count = options.length;
      if (!count) {
        var empty = el('li', 'predictive__empty', (S.searchNoResults || 'No suggestions for “[terms]”.').replace('[terms]', q));
        empty.setAttribute('role', 'presentation'); list.appendChild(empty);
      }
      var params = new URLSearchParams(new FormData(form));
      var allWrap = el('li', 'predictive__group'); allWrap.setAttribute('role', 'presentation');
      var allUl = el('ul', 'predictive__list'); allUl.setAttribute('role', 'group');
      allUl.appendChild(option((R.search || '/search') + '?' + params.toString(), function (a) {
        a.textContent = (S.searchFor || 'Search for “[terms]”').replace('[terms]', q);
      }, 'predictive__all'));
      allWrap.appendChild(allUl); list.appendChild(allWrap);
      panel.appendChild(list);
      input.setAttribute('aria-controls', listId); /* only once the listbox exists */
      panel.hidden = false; input.setAttribute('aria-expanded', 'true');
      if (status) status.textContent = (S.searchResultsCount || '[count] suggestions').replace('[count]', count);
    }
    var fetchResults = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === lastQuery && !panel.hidden) return;
      lastQuery = q;
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = R.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' + (T.searchPrefix ? '&resources[options][prefix]=last' : '');
      if (status) status.textContent = S.searchLoading || 'Loading…';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(d, q); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') close(); });
    }, 220);

    on(input, 'input', fetchResults);
    on(input, 'focus', function () { if (input.value.trim().length >= 2 && options.length) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    on(input, 'keydown', function (e) {
      if (panel.hidden) { if (e.key === 'ArrowDown' && input.value.trim().length >= 2) { lastQuery = ''; fetchResults(); } return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1 >= options.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1 < 0 ? options.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active >= 0 && options[active]) { e.preventDefault(); window.location.href = $('a', options[active]).href; }
      else if (e.key === 'Escape') { e.stopPropagation(); close(); }
    });
    on(document, 'click', function (e) { if (!form.contains(e.target)) close(); });
    on(form, 'focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 120); });
  }
  $$('form[data-predictive-search]').forEach(initPredictive);

  /* ---------- quantity steppers ---------- */
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]'); var input = wrap && $('input', wrap);
    if (!input) return;
    var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
    var v = parseInt(input.value, 10) || 0;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart: drawer, add, change ---------- */
  var drawerId = 'cart-drawer';
  function cartDrawer() { return document.getElementById('CartDrawer'); }
  var lastFocus = null;
  function openDrawer() {
    var d = cartDrawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false; document.documentElement.style.overflow = 'hidden';
    var panel = $('.drawer__panel', d); if (panel) panel.focus();
    return true;
  }
  function closeDrawer() {
    var d = cartDrawer(); if (!d || d.hidden) return;
    d.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  on(document, 'click', function (e) {
    if (e.target.closest('[data-drawer-close]') && e.target.closest('[data-cart-drawer]')) { e.preventDefault(); closeDrawer(); return; }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && T.cartType === 'drawer' && cartDrawer()) { e.preventDefault(); openDrawer(); }
  });
  on(document, 'keydown', function (e) {
    var d = cartDrawer(); if (!d || d.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select', d).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  function sectionIds() {
    var ids = ['cart-icon-bubble'];
    if (cartDrawer()) ids.push(drawerId);
    var page = $('[data-cart-section]'); if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-icon-bubble'] != null) {
      var doc = parseHTML(sections['cart-icon-bubble']);
      var src = $('.shopify-section', doc) || doc.body;
      $$('[data-cart-count]').forEach(function (n) { n.innerHTML = src.innerHTML; });
    }
    if (sections[drawerId] && cartDrawer()) {
      var dd = parseHTML(sections[drawerId]);
      var fresh = $('#CartDrawer', dd);
      var cur = cartDrawer();
      if (fresh) { var wasOpen = !cur.hidden; cur.innerHTML = fresh.innerHTML; cur.hidden = !wasOpen; }
    }
    var page = $('[data-cart-section]');
    if (page) {
      var id = page.getAttribute('data-section-id');
      if (sections[id]) {
        var pd = parseHTML(sections[id]);
        var freshPage = $('[data-cart-section]', pd);
        if (freshPage) page.innerHTML = freshPage.innerHTML;
      }
    }
  }
  function announce(msg) { $$('[data-cart-live]').forEach(function (n) { n.textContent = msg; }); }

  on(document, 'submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !window.fetch || !R.cartAdd) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var label = btn && ($('[data-add-label]', btn) || $('span', btn));
    var original = label ? label.textContent : '';
    var errorBox = $('[data-form-error]', form);
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = S.adding || 'Adding…';
    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) {
          var msg = (res.d && (res.d.description || res.d.message)) || S.cartError;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { toast(msg, true); }
          return;
        }
        applySections(res.d.sections);
        if (label) label.textContent = S.added || 'Added';
        if (T.cartType === 'drawer' && cartDrawer()) { openDrawer(); }
        else { toast(S.added || 'Added to cart', false, { href: R.cart || '/cart', label: S.viewCart || 'View cart' }); }
        announce(S.added || 'Added to cart');
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
        setTimeout(function () { if (label) label.textContent = original; }, 1200);
      });
  });

  function changeLine(line, quantity, row) {
    if (!R.cartChange) return;
    if (row) row.classList.add('is-loading');
    fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) { toast((res.d && res.d.description) || S.cartError, true); if (row) row.classList.remove('is-loading'); return; }
        applySections(res.d.sections);
        announce(quantity === 0 ? (S.itemRemoved || 'Item removed') : (S.cartUpdated || 'Cart updated'));
      })
      .catch(function () { toast(S.cartError, true); if (row) row.classList.remove('is-loading'); });
  }
  var qtyTimers = {};
  on(document, 'change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) {
      var line = parseInt(input.getAttribute('data-line'), 10);
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      clearTimeout(qtyTimers[line]);
      qtyTimers[line] = setTimeout(function () { changeLine(line, q, input.closest('[data-cart-line]')); }, 350);
      return;
    }
    var note = e.target.closest('[data-cart-note]');
    if (note && R.cartUpdate) {
      fetch(R.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) })
        .then(function () { announce(S.cartUpdated || 'Cart updated'); });
    }
  });
  on(document, 'click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm || !R.cartChange) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line'), 10), 0, rm.closest('[data-cart-line]'));
  });

  /* ---------- collection / search: filters, sort, view ---------- */
  function cleanAndSubmit(form) {
    $$('input', form).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && i.value === '') i.disabled = true; });
    var sort = $('[data-sort-select][form="' + form.id + '"]');
    if (sort && !sort.value) sort.disabled = true;
    form.submit();
  }
  $$('form[data-facets-form]').forEach(function (form) {
    on(form, 'change', function (e) { if (e.target.type === 'checkbox') cleanAndSubmit(form); });
    on(form, 'submit', function (e) { e.preventDefault(); cleanAndSubmit(form); });
  });
  $$('[data-sort-select]').forEach(function (s) {
    on(s, 'change', function () { var f = document.getElementById(s.getAttribute('form')); if (f) cleanAndSubmit(f); });
  });
  $$('[data-facet-values]').forEach(function (list) {
    var more = list.parentElement.querySelector('[data-facet-more]');
    if (!more || !list.classList.contains('is-collapsed')) return; /* collapsed in the HTML (snippets/facets.liquid) */
    on(more, 'click', function () {
      var collapsed = list.classList.toggle('is-collapsed');
      more.textContent = collapsed ? (S.showMore || 'Show more') : (S.showLess || 'Show less');
      more.setAttribute('aria-expanded', String(!collapsed));
    });
  });
  $$('[data-facets-open]').forEach(function (b) {
    var aside = document.getElementById(b.getAttribute('aria-controls'));
    if (!aside) return;
    on(b, 'click', function () {
      aside.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      var c = $('[data-facets-close]', aside); if (c) c.focus();
    });
    $$('[data-facets-close]', aside).forEach(function (c) {
      on(c, 'click', function () {
        aside.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; b.focus();
      });
    });
    on(aside, 'keydown', function (e) { if (e.key === 'Escape' && aside.classList.contains('is-open')) { $('[data-facets-close]', aside).click(); } });
  });

  function setView(v) {
    document.documentElement.setAttribute('data-view', v);
    try { localStorage.setItem('j3:view', v); } catch (e) { /* private mode */ }
    $$('[data-view-set]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-view-set') === v)); });
  }
  if ($('[data-view-set]')) {
    setView(document.documentElement.getAttribute('data-view') || 'grid');
    $$('[data-view-set]').forEach(function (b) { on(b, 'click', function () { setView(b.getAttribute('data-view-set')); }); });
  }

  /* ---------- collection description: clamp + read more ---------- */
  /* The clamp itself is CSS (no layout shift); the script only adds the toggle and hides it when the text fits. */
  $$('[data-clamp]').forEach(function (box) {
    var btn = box.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    var fits = box.scrollHeight - box.clientHeight < 4;
    if (fits) { btn.hidden = true; return; }
    btn.hidden = false;
    var more = btn.textContent;
    on(btn, 'click', function () {
      var expanded = box.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? (S.showLess || 'Show less') : more;
    });
  });

  /* ---------- product gallery + lightbox ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    if (!track) return;
    var slides = $$('[data-gallery-slide]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var current = $('[data-gallery-current]', g);
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    var index = 0;
    if (prev) prev.hidden = false; if (next) next.hidden = false;
    function go(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === index && current && current.textContent === String(i + 1)) return;
      index = i;
      if (current) current.textContent = String(i + 1);
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    on(track, 'scroll', debounce(sync, 60), { passive: true });
    thumbs.forEach(function (t) { on(t, 'click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
    on(prev, 'click', function () { go(index - 1); });
    on(next, 'click', function () { go(index + 1); });

    var box = $('[data-lightbox]', g.closest('[data-product-section]') || document);
    var zooms = $$('[data-gallery-zoom]', g);
    if (!box || typeof box.showModal !== 'function' || !zooms.length) return;
    var holder = $('[data-lightbox-media]', box), counter = $('[data-lightbox-counter]', box), li = 0;
    var img = el('img', 'lightbox__img'); img.width = 1200; img.height = 1200; img.decoding = 'async';
    if (holder) holder.appendChild(img);
    function show(i) {
      li = (i + zooms.length) % zooms.length;
      var src = zooms[li].getAttribute('href');
      var alt = ($('img', zooms[li]) || {}).alt || '';
      img.src = src; img.alt = alt;
      if (counter) counter.textContent = (li + 1) + ' / ' + zooms.length;
      $$('[data-lightbox-prev], [data-lightbox-next]', box).forEach(function (b) { b.hidden = zooms.length < 2; });
    }
    zooms.forEach(function (z, i) { on(z, 'click', function (e) { e.preventDefault(); show(i); box.showModal(); }); });
    on($('[data-lightbox-close]', box), 'click', function () { box.close(); });
    on($('[data-lightbox-prev]', box), 'click', function () { show(li - 1); });
    on($('[data-lightbox-next]', box), 'click', function () { show(li + 1); });
    on(box, 'click', function (e) { if (e.target === box || e.target.classList.contains('lightbox__inner')) box.close(); });
    on(box, 'keydown', function (e) { if (e.key === 'ArrowLeft') show(li - 1); if (e.key === 'ArrowRight') show(li + 1); });
    on(box, 'close', function () { go(li); });
  });

  /* ---------- copy link ---------- */
  $$('[data-copy-link]').forEach(function (b) {
    if (!navigator.clipboard) return;
    b.hidden = false;
    on(b, 'click', function () { navigator.clipboard.writeText(b.getAttribute('data-copy-link')).then(function () { toast(S.copied || 'Link copied'); }); });
  });

  /* ---------- recently viewed (this browser only) ---------- */
  var RV_KEY = 'j3:recently-viewed';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function rvWrite(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* ignore */ } }
  var rvItem = $('[data-recently-viewed-item]');
  var rvSection = $('[data-recently-viewed]');
  var rvList = rvRead();
  if (rvSection) {
    var currentHandle = rvSection.getAttribute('data-current');
    var limit = parseInt(rvSection.getAttribute('data-limit'), 10) || 6;
    var items = rvList.filter(function (p) { return p && p.handle !== currentHandle; }).slice(0, limit);
    var ul = $('[data-recently-viewed-list]', rvSection);
    if (items.length && ul) {
      items.forEach(function (p) {
        var li = el('li');
        var a = el('a', 'mini-card'); a.href = p.url;
        var media = el('span', 'mini-card__media');
        if (p.image) { var im = el('img'); im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.width = 200; im.height = 200; media.appendChild(im); }
        a.appendChild(media);
        var body = el('span', 'mini-card__body');
        if (p.vendor) body.appendChild(el('span', 'mini-card__vendor', p.vendor));
        body.appendChild(el('span', 'mini-card__title', p.title));
        body.appendChild(el('span', 'mini-card__price', p.available ? p.price : (S.outOfStock || 'Out of stock')));
        a.appendChild(body); li.appendChild(a); ul.appendChild(li);
      });
      rvSection.hidden = false;
    }
    on($('[data-recently-viewed-clear]', rvSection), 'click', function () { rvWrite([]); rvSection.hidden = true; });
  }
  if (rvItem) {
    try {
      var item = JSON.parse(rvItem.textContent);
      rvList = rvList.filter(function (p) { return p && p.handle !== item.handle; });
      rvList.unshift(item); rvWrite(rvList);
    } catch (e) { /* ignore */ }
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url || box.children.length) return;
    function load() {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = $('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; } else { box.hidden = true; }
      }).catch(function () { box.hidden = true; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px 0px' });
      io.observe(box);
    } else { load(); }
  });

  /* ---------- customer addresses ---------- */
  function initAddresses() {
    if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return;
    $$('[data-address-country]').forEach(function (sel) {
      var suffix = sel.getAttribute('data-address-country');
      new window.Shopify.CountryProvinceSelector('AddressCountry' + suffix, 'AddressProvince' + suffix, { hideElement: 'AddressProvinceContainer' + suffix });
    });
  }
  if (document.readyState === 'complete') initAddresses(); else on(window, 'load', initAddresses);
  on(document, 'submit', function (e) {
    var b = e.target.querySelector && e.target.querySelector('[data-confirm]');
    if (b && !window.confirm(b.getAttribute('data-confirm'))) e.preventDefault();
  });

  /* ---------- circuit background: pause its animation while the band is off-screen (saves battery) ---------- */
  if ('IntersectionObserver' in window) {
    $$('[data-circuit-bg]').forEach(function (bg) {
      new IntersectionObserver(function (entries) {
        bg.classList.toggle('is-paused', !entries[0].isIntersecting);
      }).observe(bg);
    });
  }

  /* ---------- wide tables in rich text: keyboard-scrollable (WCAG 2.1.1) ---------- */
  $$('.rte table').forEach(function (t) {
    if (t.scrollWidth > t.clientWidth + 1 && !t.hasAttribute('tabindex')) {
      t.setAttribute('tabindex', '0');
      if (!t.hasAttribute('aria-label')) {
        var cap = t.querySelector('caption, th');
        t.setAttribute('aria-label', cap && cap.textContent.trim() ? cap.textContent.trim().slice(0, 80) : (document.title || 'Table'));
      }
    }
  });

  /* ---------- focus result notices after a form post ---------- */
  var notice = $('.notice[tabindex="-1"]');
  if (notice && notice.closest('form')) { notice.focus(); }
})();
